module.exports = __webpack_public_path__ + "img/pound-euro.bd08e0dc.png";